import {useState} from 'react'
import {BasicBreadcrumbs} from 'src/app/shared/BasicBreadcrumbs'
import {KTCard} from '../../../../_metronic/helpers'
import {Enterprice, PartnerContext} from './PartnerContexts'
import {AsignacionUnidadHeader} from './components/AsignacionUnidadHeader'
import {AsignacionUnidadTable} from './components/AsignacionUnidadTable'
import {EditUserModal} from './show-edit-user-modal/EditUserModal'

const historialDocumentsBreadcrumbs = [
  {
    title: 'Seguridad',
    path: '/seguridad/asignacionunidad',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const AginacionUnidadPage = () => {
  const [activeOnly, setActiveOnly] = useState(true)
  const [state, setState] = useState<string[]>([])
  const [searchTerm, setSearchTerm] = useState('')
  const [entryDateFrom, setEntryDateFrom] = useState()
  const [entryDateTo, setEntryDateTo] = useState()
  const [isEditUserModalOpen, setIsEditUserModalOpen] = useState(false)
  const [userData, setUserData] = useState<{}>({})
  const [updateUser, setUpdateUser] = useState(false)
  const [enterprices, setEnterprices] = useState<Enterprice[]>([])
  const [currentPage, setCurrentPage] = useState(1)

  const openEditUserModal = () => {
    setIsEditUserModalOpen(true)
  }

  const closeEditUserModal = () => {
    setIsEditUserModalOpen(false)
  }
  return (
    <>
      <PartnerContext.Provider
        value={{
          activeOnly,
          setActiveOnly,
          state,
          setState,
          searchTerm,
          setSearchTerm,
          entryDateFrom,
          setEntryDateFrom,
          entryDateTo,
          setEntryDateTo,
          isEditUserModalOpen,
          openEditUserModal,
          closeEditUserModal,
          userData,
          setUserData,
          updateUser,
          setUpdateUser,
          enterprices,
          setEnterprices,
          currentPage,
          setCurrentPage,
        }}
      >
        <BasicBreadcrumbs
          breadcrumbs={historialDocumentsBreadcrumbs}
          fallbackTitle='Asignación de Unidades'
        />
        <KTCard>
          <AsignacionUnidadHeader />
          <AsignacionUnidadTable />
        </KTCard>
        <EditUserModal />
      </PartnerContext.Provider>
    </>
  )
}

export {AginacionUnidadPage}
